export class DuplicateEmailTemplateRequest {
    EmailTemplateID: number;
}
